/**
 * Previous Step Edit API Utilities
 * Handles API calls for previous step edit saves
 */

import type { RootState } from '../data-layer/reduxTypes';

import { buildConnectionPayload } from './connectionUtils';
import { replacePlaceholders } from './placeholderIndexUtils';

/**
 * Save configuration for previous step edit (no transitions)
 */
const savePreviousStepConfiguration = async (
  stepName: string,
  formData: Record<string, unknown>,
  services: {
    testConnection?: (payload: unknown) => Promise<unknown>;
    saveUseCaseConfiguration?: (payload: {
      applicationtype: string;
      endpointKey: string | number;
      body: unknown;
    }) => Promise<unknown>;
  },
  getState: () => RootState
): Promise<void> => {
  const rootState = getState();

  if (stepName === 'Connection') {
    const endpointKey = rootState.copilot.endpointKey || '';
    const generalData = rootState.copilot.stepFormData.General || {};
    const applicationtype = String(
      generalData['securitysystems.systemtype'] || 'CUA'
    );

    // Build connection payload with @CUAPROMPT@ placeholder
    const connectionPayload = buildConnectionPayload(formData, '@CUAPROMPT@');

    await services.saveUseCaseConfiguration?.({
      applicationtype,
      endpointKey,
      body: connectionPayload,
    });

    await services.testConnection?.({
      endpointName: String(generalData['securitysystems.systemname'] || ''),
    });
  } else {
    const endpointKey = rootState.copilot.endpointKey || '';
    const generalData = rootState.copilot.stepFormData.General || {};
    const applicationtype = String(
      generalData['externalconnectiontype.connectionType'] || 'CUA'
    );

    // Get user prompt for this step
    const userPrompt = String(rootState.copilot.accountPrompts[stepName] || '');

    // Replace @CUAPROMPT@ with user prompt
    const processedFormData = replacePlaceholders(formData, userPrompt);

    // Create a copy and remove mappings from payload
    const cleanFormData = { ...processedFormData };

    delete cleanFormData.mappings;

    await services.saveUseCaseConfiguration?.({
      applicationtype,
      endpointKey,
      body: cleanFormData,
    });
  }
};

export default savePreviousStepConfiguration;
